<template>
    <div>
        <el-card class="box-card" style="margin-bottom: 12px;position: relative;">
            <el-form :model="formInfo">
                <el-form-item label="">
                    <el-input v-model="formInfo.searchValue" size="small" placeholder="请输入项目名称/项目编号/招标人名称/中标人名称" clearable
                        style="width:400px">
                        <el-button slot="append" size="mini" icon="el-icon-search" @click="searchChange"></el-button>
                    </el-input>
                </el-form-item>
            </el-form>
        </el-card>

        <el-card class="box-card" style="margin-bottom: 12px;position: relative;">
            <div>
                <!-- 项目状态 -->
                项目状态:
                <el-radio-group v-model="status" size="mini">
                    <el-radio label="" border>全部</el-radio>
                    <el-radio label="1" border>未开始</el-radio>
                    <el-radio label="2" border>已开标（未完成）</el-radio>
                    <el-radio label="3" border>已完结</el-radio>
                    <el-radio label="4" border>招标异常</el-radio>
                </el-radio-group>
            </div>
        </el-card>
        <el-card class="box-card">
            <div class="projectBox" v-loading="getDataLoading" :style="{ 'min-height': cardHeight }">
                <emptyInfo v-if="dataList.length == 0" :emptyMsg="'暂无表单数据'" ></emptyInfo>
                <ProjectItem v-for="(item, index) in dataList" :projectObj="item" :key="index" :businessType="businessType"
                    :project-index="index" :stateList="bidStateList" :bidType="'tender'"></ProjectItem>
            </div>
            <!-- <el-pagination class="paginationCom" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"
                :current-page="pageIndex" :page-sizes="[5, 20, 50, 100]" :page-size="pageSize" :total="total"
                layout="total, sizes, prev, pager, next, jumper"></el-pagination> -->
                <pagination
                    class="limit paginationCom"
                    :page-sizes="[5, 20, 50, 100]"
                    :total="total"
                    :page.sync="pageIndex"
                    :limit.sync="pageSize"
                    @pagination="paginationChange">
                </pagination>
        </el-card>
    </div>
</template>

<script>
import ProjectItem from '@/components/projectItem'
import { getProjectList } from '@/server/common'
import emptyInfo from '@/components/empty-info';
import Pagination from '@/components/Pagination.vue';
export default {
    name: 'projectList',
    components: {
        ProjectItem,
        emptyInfo,
        Pagination
    },
    data() {
        return {
            formInfo: {
                searchValue: ''
            },
            status: "",
            bidStateList: [],
            businessType: '',
            pageIndex: 1,
            pageSize: 5,
            total: 0,
            dataList: [],
            getDataLoading: false,
            cardHeight:document.documentElement.clientHeight - 307 + 'px',
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            this.getDataLoading = true
            getProjectList({
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                searchValue: this.formInfo.searchValue
            }).then(res => {
                this.getDataLoading = false
                if (res.code == 0) {
                    this.dataList = res.data.list
                    this.total = res.data.total
                }
            })
        },
        searchChange() {
            this.pageIndex = 1
            this.getData()
        },
        sizeChangeHandle(val) {
            this.pageSize = val
            this.getData()
        },
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getData()
        },
        paginationChange(obj){
         this.pageIndex= obj.page||1
         this.pageSize=obj.limit||5
         this.getData();
        },
    }
}

</script>

<style lang="less" scoped>
    /deep/ .el-radio__input {
        display: none;
    }
</style>